import { Component, inject, OnDestroy, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppUser, AuthService, EMPTY } from '@app/components/login.component';
import { ParentItemProviderService } from '@app/shared';
import { DynamicFormService } from '@ntap/common';
import {
  BackendDataSourceService,
  FilterView,
  ItemView,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NtapCommonComponent,
  UIComponents,
  ViewData
} from '@ntap/core';
import { combineLatest, map, Observable, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-spremiste-objekti-view',
  templateUrl: './spremiste-objekti-view.component.html',
  styleUrls: ['./spremiste-objekti-view.component.scss'],
  providers: [ParentItemProviderService]
})
export class SpremisteObjektiViewComponent
  extends NtapCommonComponent
  implements OnDestroy
{
  INIT_COMP_ID = UIComponents.ITEMVIEW;
  arhiv: string;
  arhivId: string;
  parentArchiveName: Observable<ViewData>;
  filterDataArchiveId: number;
  user$: Observable<AppUser | EMPTY>;
  userMaticnaInstitucijaId: number;

  backendService = inject(BackendDataSourceService);
  formService = inject(DynamicFormService);

  constructor(
    protected route: ActivatedRoute,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    @Optional()
    protected listViewProviderDirective: ListViewProviderDirective<FilterView>,
    public authService: AuthService
  ) {
    super();
    this.user$ = this.authService.user$;
    this.itemViewProvider;

    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          tap((item: any) => {
            this.arhiv =
              (item['earhiv~spremiste_objekt~identifikator']
                ? item['earhiv~spremiste_objekt~identifikator'] + ' '
                : '') +
              (item['earhiv~spremiste_objekt~naziv']
                ? item['earhiv~spremiste_objekt~naziv']
                : '');
          }),
          switchMap((item: any) => {
            // Provjerite postoji li arhiv_id
            if (item['earhiv~spremiste_objekt~arhiv_id'] != null) {
              // Vraća Observable iz backendService
              return this.backendService
                .getViewData('spremiste_nadredeni-arhiv', {
                  ['en~arhiv_posjednik~id']:
                    item['earhiv~spremiste_objekt~arhiv_id']
                })
                .pipe(
                  tap((parentArhiv: any) => {
                    // Postavljanje parentArchiveName
                    this.parentArchiveName =
                      parentArhiv.length > 0
                        ? parentArhiv[0]['en~agent~naziv']
                        : '';
                  })
                );
            } else {
              // Ako nema arhiv_id, vraćamo prazan Observable
              return of(null);
            }
          })
        )
        .subscribe()
    );

    this.addSubscription(
      combineLatest([
        this.itemViewProvider.item$.pipe(), // item
        this.user$.pipe(map((user) => user.maticnaInstitucijaId)) // user
      ])
        .pipe(
          tap(([item, userMaticna]: [item: any, userMaticna: any]) => {
            // FIXME ovo nije dobro - uzima se iz liste, što znaci da se filtriranje mora pokrenuti da bi podatak bio dostupan u viewState
            // Trenutno framework ne exposa u filterViewProvider viewData
            // a ionako trebamo za odabir arhiva / kataloga implementirati neku zajednicku komponentu u navigacijskoj traci
            const maticnaId =
              item['earhiv~spremiste_objekt~arhiv_id'] ||
              (this.listViewProviderDirective?.viewState as any)[
                'earhiv~spremiste~arhiv_id'
              ] ||
              userMaticna;
            item['earhiv~spremiste_objekt~arhiv_id'] = maticnaId;
          })
        )
        .subscribe()
    );
  }
}
